import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-a220-steps',
  templateUrl: './a220-steps.component.html',
  styleUrls: ['./a220-steps.component.scss']
})
export class A220StepsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
